export const BROADCAST_TYPES = ["announcement", "article", "reminder", "reset"];
export const BROADCAST_AUDIENCES = ["company", "group", "user", "all"];
export const BROADCAST_CHANNELS = ["app", "mobile", "desktop", "slack", "teams"];
/** Every channel but the in-app modal is a push, named as the notification fanout names it. */
const PUSH_CHANNEL = {
    mobile: "onesignal",
    desktop: "web-push",
    slack: "slack",
    teams: "msteams",
};
export function broadcastPushChannels(channels) {
    return channels.flatMap((c) => (c === "app" ? [] : [PUSH_CHANNEL[c]]));
}
/** The moments rule a delivered broadcast is recorded under. */
export const BROADCAST_RULE = "broadcast";
/** The attention event kind a delivered broadcast arrives as. */
export const BROADCAST_EVENT_KIND = "broadcast";
/** How long an unanswered broadcast keeps asking. */
export const BROADCAST_SHOW_DAYS = 7;
/** The types that point at one library item. */
export function broadcastNeedsContent(type) {
    return type === "article" || type === "reset";
}
/** The types that may carry a web link instead of a library item. */
export function broadcastTakesLink(type) {
    return type === "announcement" || type === "reminder";
}
/** https only: a broadcast link reaches every member, so it must never be javascript:, data: or plain http. */
export function safeBroadcastUrl(raw) {
    if (!raw)
        return null;
    try {
        const url = new URL(raw.trim());
        return url.protocol === "https:" && url.hostname.includes(".") ? url.toString() : null;
    }
    catch {
        return null;
    }
}
export function broadcastLinkHost(url) {
    return new URL(url).hostname.replace(/^www\./, "");
}
/** Where the broadcast takes the member: the item it names, or Today. */
export function broadcastLink(type, contentId) {
    if (contentId && broadcastNeedsContent(type)) {
        return `/explore?content=${encodeURIComponent(contentId)}&kind=${type}`;
    }
    return "/today";
}
const LABELS = {
    announcement: { eyebrow: "Announcement", cta: "Got it" },
    reminder: { eyebrow: "Reminder", cta: "Got it" },
    article: { eyebrow: "Article", cta: "Read it" },
    reset: { eyebrow: "Reset", cta: "Start the reset" },
};
export function broadcastEyebrow(type) {
    return LABELS[type].eyebrow;
}
export function broadcastCta(type) {
    return LABELS[type].cta;
}
export function isBroadcastType(value) {
    return typeof value === "string" && BROADCAST_TYPES.includes(value);
}
//# sourceMappingURL=broadcast.js.map